// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"ea0ac57e","308":"cca78e60","511":"a4f868b5"}[chunkId] + ".chunk.js";
};